var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'bg-gray-200 rounded dark:bg-gray-700': _vm.isLoading }},[(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }